import ExtrasHotel from './ExtrasHotel';

export default ExtrasHotel;
